import type { GroupSubtypeEnum } from 'app/schemas/plan';
import { PlanRecurrenceEnum } from 'app/schemas/plan';
import {
  DEFAULT_PLAN_CODE,
  isFreeTrialPlanCode,
  OFFRE_DEFRICHEURS_PLAN_CODE,
  OFFRE_TRIAL_PLAN_CODE,
  REFERRAL_PRIZE_PLAN_CODE,
} from 'app/network/plan';
import { WhiteLabel } from 'app/types/white-labels';
import { isWhiteLabel } from 'app/utils/helpers';

export const buildTextPlan = (
  entity: 'title' | 'firstParagraph',
  planCode?: string,
  groupSubtype?: GroupSubtypeEnum,
  recurrence?: PlanRecurrenceEnum,
) => {
  if (isFreeTrialPlanCode(planCode)) return `trialPlan.${entity}`;

  switch (planCode) {
    case undefined:
      return '-';
    case DEFAULT_PLAN_CODE:
      if (recurrence === PlanRecurrenceEnum.yearly) return `regularYearlyPlan.${entity}`;
      if (recurrence === PlanRecurrenceEnum.monthly) return `regularMonthlyPlan.${entity}`;
      return `regularPlan.${entity}`;
    case OFFRE_DEFRICHEURS_PLAN_CODE:
      return `defricheurPlan.${entity}`;
    case OFFRE_TRIAL_PLAN_CODE:
      return `offreTrialPlan.${entity}`;
    case REFERRAL_PRIZE_PLAN_CODE:
      return `referralPrizePlan.${entity}`;
    default:
      if (planCode.startsWith('DG-')) return `dragonPlan.${entity}`;
      if (planCode.startsWith('CD-')) return `giftPlan.${entity}`;
      if (planCode.startsWith('AR-') && isWhiteLabel(WhiteLabel.Refrain)) return `refrainPlan.${entity}`;
      return `businessPlan.${entity}.${groupSubtype ?? 'generic'}`;
  }
};
